/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Grid } from '@material-ui/core';
// import 'moment/locale/en-SG';
import classnames from 'classnames';
import { useTranslate } from '@/locale';
import {
  MessageProps,
  RenderBannerTypeProps,
  BannerProps,
  Status,
} from '@/types';
import closeIcon from '@/assets/images/close.png';
import logoLifepack from '@/assets/images/lifepack_logo.png';
import { Card, Button } from '@/components/uikit';
import { deviceDetect, formatTime } from '@/utils/helper';

import { ColorList } from '../Interface';

const Message = ({
  subscription,
  date,
  titleTestId,
  descTestId,
  customDateFormat = 'dddd, D MMMM YYYY. HH.mm',
  subscriptionID,
  remainingTime,
  title,
  description,
}: MessageProps) => {
  const { translate, currentLanguage } = useTranslate();
  let newDescription = description;

  if (date) {
    const isDate = formatTime(date, customDateFormat, currentLanguage);
    newDescription += ` ${isDate}`;
    if (customDateFormat === 'dddd, D MMMM YYYY. HH.mm') {
      newDescription += ' WIB';
    }
  }

  let titleColor = '';
  const { status, order_status } = subscription;

  if (status === 'waiting_for_payment') {
    titleColor = 'tingerine';
  }

  if (
    status === 'payment_expired' ||
    status === 'payment_failed' ||
    status === 'order_cancelled'
  ) {
    titleColor = 'coraltwo';
  }

  if (
    (status === 'payment_order' || status === 'pending_address') &&
    order_status === 'expired'
  ) {
    titleColor = 'coraltwo';
  }

  const timeToArray = remainingTime ? remainingTime?.split(':') : false;

  return (
    <>
      <Card className="message-status">
        <p className="prescription-detail-title">Status</p>
        <div className="message-content">
          <p
            data-testid={titleTestId}
            className={classnames('title', titleColor)}
          >
            {title}
          </p>
          {timeToArray && (
            <div className="count-down">
              {timeToArray.map((val, index) => (
                <React.Fragment key={index}>
                  <span>{val}</span>
                  {timeToArray?.length !== index + 1 && <p>:</p>}
                </React.Fragment>
              ))}
            </div>
          )}
        </div>
        <p
          data-testid={descTestId}
          style={{ marginTop: '0px' }}
          className="desc"
        >
          {newDescription}
        </p>
        <div>
          <p className="prescription-detail-title">
            {translate('orderNumber')}
          </p>
          <p>{`#${subscriptionID}`}</p>
        </div>
      </Card>
    </>
  );
};

const RenderBannerType = (props: RenderBannerTypeProps) => {
  const [bannerVisible, setBannerVisible] = useState(true);
  const { type, right = 20 } = props;
  const query = new URLSearchParams(useLocation().search);
  const partnerInsuranceId = query.get('partner_insurance_id');

  const handleButtonClick = () => {
    let destination =
      'https://play.google.com/store/apps/details?id=com.itmi.lifepack';
    if (deviceDetect.isIOS) {
      destination = 'https://apps.apple.com/id/app/id1497488622';
    }

    window.open(destination, '_blank');
  };

  const handleLeftIconClick = () => {
    setBannerVisible(false);
  };

  if (partnerInsuranceId != null) {
    return <></>;
  }

  switch (type) {
    case 'app-install':
      return (
        <Banner
          onClickLeftIcon={handleLeftIconClick}
          isVisible={bannerVisible}
          iconLeft={closeIcon}
          right={right}
          imageLeft={logoLifepack}
          bodyText="Easier only in the Lifepack application."
          rightNode={() => (
            <Button
              color={ColorList.BLUE_BRIGHT}
              fullWidth={false}
              size="small"
              onClick={handleButtonClick}
            >
              Install
            </Button>
          )}
        />
      );
    default:
      return null;
  }
};

const Banner = (props: BannerProps) => {
  const {
    iconLeft,
    imageLeft,
    bodyText,
    rightNode,
    color = 'flash',
    isVisible,
    onClickLeftIcon,
    right,
  } = props;

  return isVisible ? (
    <Card style={{ marginBottom: 0 }} color={color} className="message-info">
      <Grid
        container
        item
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <div className="banner">
          <img
            onClick={onClickLeftIcon}
            role="button"
            src={iconLeft}
            alt="close-icon"
            height="20"
          />
          <img src={imageLeft} alt="lifepack_logo" height="34" />
          <p style={{ maxWidth: '110pt' }} className="desc">
            {bodyText}
          </p>
        </div>
        {rightNode()}
      </Grid>
    </Card>
  ) : null;
};

export { Message, RenderBannerType as Banner };
